"use client";
import { LayoutProps } from "@/components/layout/layoutType";
import DataList from "@/components/layout/data/list/datalist";
import { useDataListRef } from "@/app/hook/useDataListRef";
import { getDataListProp } from "../layout/list/dataListProp";
import Signin from "../layout/user/signin";
import Underconstruction from "./underconstruction";
import { Debug } from "@/util/debug";
import { NextIntlClientProvider, useLocale, useMessages, useTranslations } from "next-intl";

// import { useMessages as useMessagesHook } from "@/app/hook/useMessages";
// import { getMessageFallback, intlError } from "./main";
import { AlertContext } from "../context/alertContext";
import { useContext, useEffect, useMemo, useState } from "react";
import { checkMobile } from "@/util/checkMobile";
import { useRouter } from "next/navigation";
import { App } from "antd";
// const DataList = dynamic(() => import("@/components/layout/data/list/datalist"), { ssr: false });
const ssr = process.env.NEXT_PUBLIC_I18N === "ssr";
export default function DefaultDataList({ params }: { params?: LayoutProps }) {
  const { form, setFormFunction, fieldChange, formMemo, formFunction, setValueList, dataFunction, initFunction, setSubDataFunction } =
    useDataListRef();
  const t = useTranslations("contents");
  const ta = useTranslations("alert");
  const router = useRouter();
  // const locale = useLocale();
  // const messages = useMessagesHook(locale);
  const alertContext = useContext(AlertContext);
  const [isMobile, setMobile] = useState(checkMobile());
  const { message } = App.useApp();
  //const [isMobile, setMobile] = useState(checkMobile());
  useEffect(() => {
    let now_mobile = isMobile;
    let width = 0;
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target.tagName === "BODY") {
          if (width !== entry.contentRect.width) {
            width = entry.contentRect.width;
            const check_mobile = checkMobile();
            if (now_mobile != check_mobile) {
              Debug("change mobile", now_mobile, check_mobile);
              now_mobile = check_mobile;
              setMobile(() => check_mobile);
            }
          }
        }
      });
    });

    if (document.body) {
      resizeObserver.observe(document.body);
    }

    return () => {
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const listProp = getDataListProp({
    t,
    ta,
    router,
    params,
    form: form,
    formMemo: formMemo,
    formFunction,
    setValueList,
    dataFunction,
    isMobile,
    message,
    alertContext,
  });
  //
  if (listProp && (((listProp.useList ?? true) && params?.page?.listview) || params?.page?.view)) {
    // if (ssr) {
    //   if (messages) {
    //     return (
    //       <NextIntlClientProvider locale={locale} messages={messages} onError={intlError} getMessageFallback={getMessageFallback}>
    //         <DataList
    //           setForm={setFormFunction}
    //           setValuesField={fieldChange.current}
    //           setValueList={setValueList.current}
    //           setSubData={setSubDataFunction}
    //           formMemo={formMemo.current}
    //           formFunction={formFunction.current}
    //           dataFunction={dataFunction.current}
    //           alertFunction={alertContext.setProp}
    //           //loading={messages === undefined}
    //           {...listProp}
    //         />
    //       </NextIntlClientProvider>
    //     );
    //   } else {
    //     return "";
    //   }
    // } else {
    return (
      <DataList
        setForm={setFormFunction}
        setValuesField={fieldChange.current}
        setValueList={setValueList.current}
        setSubData={setSubDataFunction}
        formMemo={formMemo.current}
        formFunction={formFunction.current}
        initFunction={initFunction}
        dataFunction={dataFunction.current}
        {...listProp}
      />
    );
    // }
  } else {
    if (params != null && params.user == null) {
      return <Signin params={params} />;
    } else {
      return <Underconstruction params={params} />;
    }
  }
}
